import AdminAPI from "../apis/AdminAPI";
import store from "../store";
import AlertService from "./AlertService";

class AdminService {
  async getConfigByName(key) {
    try {
      const resp = await AdminAPI.get("config/getConfigByName/" + key);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Could not retrieve " + key);
      console.log(key + " was not found");
      return "";
    }
  }

  async getConfigItemByID(id) {
    try {
      const resp = await AdminAPI.get("config/" + id);
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async updateConfigItem(id, item) {
    try {
      await AdminAPI.patch("config/" + id, item);
      AlertService.addSuccessAlert("Successful Update");
    } catch (err) {
      console.log(err);
    }
  }

  async addConfigItem(item) {
    try {
      await AdminAPI.post("config/", item);
      AlertService.addSuccessAlert("Successful Add");
    } catch (err) {
      console.log(err);
    }
  }

  async getAllConfigItem() {
    try {
      const resp = await AdminAPI.get("config/");
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async getAllStates() {
    try {
      const resp = await AdminAPI.get("TitleIVSchool/GetAllStates");
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async searchCities(stateAbbreviation) {
    try {
      const resp = await AdminAPI.post("TitleIVSchool/SearchCities", {
        StateAbbreviation: stateAbbreviation
      });
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async SearchTitleIVSchoolNames(stateAbbreviation, city) {
    try {
      if (city === "") {
        city = null;
      }
      const resp = await AdminAPI.post(
        "TitleIVSchool/SearchTitleIVSchoolNames",
        {
          StateAbbreviation: stateAbbreviation,
          City: city
        }
      );
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async SearchIsirEnumInfo(parameters) {
    try {
      const resp = await AdminAPI.post(
        "IsirEnumInfo/search", parameters);
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async getIsirEnumInfo() {
    try {
      const resp = await AdminAPI.get("IsirEnumInfo/");
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async getOneIsirRecordInfo(id) {
    const resp = await AdminAPI.get(`IsirRecordInfo/${id}`);
    return resp.data;
  }

  async getAllIsirRecordInfo() {
    try {
      const resp = await AdminAPI.get("IsirRecordInfo/");
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async getAllIsirRecordElementInfoByAidYear(aidYear) {
    if (!aidYear) {
      aidYear = store.getState().global.aidYear;
    }
    var edYearCode = aidYear
      .toString()
      .slice(aidYear.toString().length - 1, aidYear.toString().length);
    const resp = await AdminAPI.get(
      `IsirRecordElementInfo/getByEdYearCode/${edYearCode}`
    );
    return resp.data;
  }

  async getByAidYearIsirRecordElementInfo(isSuppressed, aidYear) {
    if (!aidYear) {
      aidYear = store.getState().global.aidYear;
    }
    var edYearCode = aidYear
      .toString()
      .slice(aidYear.toString().length - 1, aidYear.toString().length);
    const resp = await AdminAPI.get(
      `IsirRecordElementInfo/getByEdYearCodeAndSuppressed/${edYearCode}/${false}`
    );
    return resp.data;
  }

  async addHoliday(holiday) {
    try {
      const resp = await AdminAPI.post(
        `holiday/`, holiday
      );
      AlertService.addSuccessAlert("Holiday Added");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Holiday could not be added");
    }
  }

  async getAllHoliday() {
    try {
      const resp = await AdminAPI.get("holiday/");
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async deleteHoliday(id) {
    try {
      await AdminAPI.delete(`holiday/${id}`);
      AlertService.addSuccessAlert("Holiday Deleted");
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async updateHoliday(id, holiday) {
    try {
      await AdminAPI.patch(`holiday/` + id, holiday);
      AlertService.addSuccessAlert("Holiday Updated");
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async getAvailableSchools(user) {
    try {
      const resp = await AdminAPI.get(`MasterUserProfile/GetAvailableSchools/${user.id}`);
      return resp.data;
    } catch (err) {
      console.log(err);
      AlertService.addErrorAlert("Something went wrong while retrieving available schools, school switching is being disabled.");
      return false;
    }
  }

  async AddNotification(notification) {
    try {
      const resp = await AdminAPI.post(`Notification`, notification);
      return resp.data
    } catch (err) {
      console.log(err);
    }
  }
  
  async SearchNotification(parameters) {
    try {
      const resp = await AdminAPI.post(
        "Notification/search", parameters);
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async UpdateNotification(notification) {
    try {
      await AdminAPI.patch(`notification/${notification.id}`, notification);
      AlertService.addSuccessAlert("Successful Update");
    } catch (err) {
      console.log(err);
    }

  }

  async getAllNotificationTemplate() {
    try {
      const resp = await AdminAPI.get("NotificationTemplate");
      return resp.data;
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async getAllBASAmount(){
    try {
      const resp = await AdminAPI.get(`BASAmount/`);
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }

  async getAllMasterSchools(){
    try {
      const resp = await AdminAPI.get(`masterschool/`);
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }

  async updateMasterSchool(id, masterSchool) {
    try {
      await AdminAPI.patch(`masterSchool/` + id, masterSchool);
    } catch (err) {
      console.log(err);
      return;
    }
  }

  async SearchMasterSchool(parameters){
    try {
      const resp = await AdminAPI.post("masterSchool/search", parameters);
      return resp.data;
    } catch(err)
    {
      console.log(err)
      return;
    }
  }
  
  async getMasterUserProfiles() {
    try {
      // need to add a check to bypass existing 'test' config that only allows this to be called from dev/staging
      let response = await AdminAPI.get("/MasterUserProfile/");
      return response.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.response?.data ?? "Failed to get MasterUserProfile");
    }
  }

  async getMasterUserProfileHistory() {
    try {
      // need to add a check to bypass existing 'test' config that only allows this to be called from dev/staging
      let response = await AdminAPI.get("/MasterUserProfile/MostRecentMasterUserProfileHistory");
      return response.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.response?.data ?? "Failed to get MasterUserProfileHistory");
    }
  }

  async updateMasterUserProfile(MasterUserProfile) {
    try {
      await AdminAPI.patch(`MasterUserProfile/${MasterUserProfile.id}`, MasterUserProfile);
      AlertService.addSuccessAlert("Successful Update");
    } catch (err) {
      AlertService.addErrorAlert(err?.response?.data ?? "Failed to update MasterUserProfile");
    }
  }

  async SearchMasterUserProfile(parameters){
    try {
      const resp = await AdminAPI.post("MasterUserProfile/search", parameters);
      return resp.data;
    } catch(err)
    {
      console.log(err)
      return;
    }
  }

  async deleteMasterUserProfile(id) {
    try {
      await AdminAPI.delete(`MasterUserProfile/deleteMasterUserProfile/${id}`);
      AlertService.addSuccessAlert("MasterUserProfile Deleted");
    } catch (err) {
      console.log(err);
      return;
    }
  }
}

let instance = new AdminService();
export default instance;
